export default class segmentationSelect {
    constructor() {
        return {
            restrict: 'A',
            scope: {
                loaded: '=',
                target: '@'
            },
            controller: [
                '$scope', '$element', '$attrs', '$timeout', '$modal', 'Segment',
                (scope, element, attr, $timeout, $modal, Segment) => {
                const target = scope.target || '_self';
                var segmentationSelect = null;

                $timeout(() => {
                    segmentationSelect = $(element).selectize({
                        valueField: 'id',
                        labelField: 'name',
                        searchField: 'name',
                        plugins: ['remove_button'],
                        preload: true,
                        create: false,

                        render: {
                            item: function(item, escape) {
                                return`<div class="segment-label">
                                            <a style="color:inherit;" href="#/filter/${item.id}" target="${target}">
                                                ${escape(item.name)}
                                            </a>
                                       </div>`;
                            }
                        },

                        load: (query, callback) => {

                            var segmentExcept = (data) =>{
                                if (attr.segmentException){
                                    data = data.filter((segment) => {
                                        return segment.id != attr.segmentException;
                                    });
                                }
                                return data;
                            };

                            if (! query.length) {
                                return Segment.all().then((segmentations) => {
                                    callback(segmentExcept(segmentations.data));
                                });
                            }

                            Segment.findByName(query).then((segmentations) => {
                                callback(segmentExcept(segmentations));
                            });
                        }
                    });

                    scope.$watch('loaded', (newVal, oldVal) => {
                        if (newVal !== false) {
                            angular.forEach(newVal, (segmentationId) => {
                                Segment.find(segmentationId).then((segment) => {
                                    $timeout(() => {
                                        segmentationSelect[0].selectize.addOption({
                                            id: segment.data.id,
                                            name: segment.data.name
                                        });
                                        segmentationSelect[0].selectize.addItem(segment.data.id);
                                        segmentationSelect[0].selectize.unlock();
                                    });
                                });
                            });
                        }
                    });
                });
            }]
        }
    }
}
